import React, { Component } from 'react'
import * as R from 'ramda'

import TwoDecimalSlider from 'components/form/twoDecimalSlider'
import {
  withReducer,
  withConnect,
  withRisk,
} from 'containers/Form/RiskSlider'

export default R.curry((path, id) => R.compose(
  withReducer(path, id),
  withConnect(path, id),
  withRisk(path, id),
)(TwoDecimalSlider))
